// Asset preloader utility

import { preload } from "react-dom";
import configs from "./configs";
import { USDC_ICON } from "./utils";

// Public assets
const PUBLIC_ASSETS = [
  // Buttons
  "https://cdn.navalabs.io/assets/button/add-squad-button-active_OqKjOn.png",
  "https://cdn.navalabs.io/assets/button/add-squad-button-hovered_HdnCMQ.png",
  "https://cdn.navalabs.io/assets/button/add-squad-button_YgBxIA.png",
  "https://cdn.navalabs.io/assets/button/custom-pill-button-active_uymeXM.png",
  "https://cdn.navalabs.io/assets/button/custom-pill-button-hovered_BGRtpS.png",
  "https://cdn.navalabs.io/assets/button/custom-pill-button_QIdZJA.png",
  "https://cdn.navalabs.io/assets/button/decrement-clicked_OeWFWP.png",
  "https://cdn.navalabs.io/assets/button/decrement-hovered_AIslOn.png",
  "https://cdn.navalabs.io/assets/button/decrement-normal_GVqDLx.png",
  "https://cdn.navalabs.io/assets/button/duration-button-active_cWjApJ.png",
  "https://cdn.navalabs.io/assets/button/duration-button-hovered_OAYMeA.png",
  "https://cdn.navalabs.io/assets/button/duration-button_tAHRgs.png",
  "https://cdn.navalabs.io/assets/button/increment-clicked_OxoYzQ.png",
  "https://cdn.navalabs.io/assets/button/increment-hovered_lYYLmZ.png",
  "https://cdn.navalabs.io/assets/button/increment-normal_vgvCEL.png",
  "https://cdn.navalabs.io/assets/button/long-button-active_Anvsgm.png",
  "https://cdn.navalabs.io/assets/button/long-button-hover_isNkjr.png",
  "https://cdn.navalabs.io/assets/button/long-button_YXXNtC.png",
  "https://cdn.navalabs.io/assets/button/short-button-active_QZzBnM.png",
  "https://cdn.navalabs.io/assets/button/short-button-hover_sscAGc.png",
  "https://cdn.navalabs.io/assets/button/short-button_CJbjIW.png",
  "https://cdn.navalabs.io/assets/button/squad-button-active_ctOPQP.png",
  "https://cdn.navalabs.io/assets/button/squad-button-hovered_BmbDsl.png",
  "https://cdn.navalabs.io/assets/button/squad-button_bdZcKO.png",
  "https://cdn.navalabs.io/components/dark-blue-elevated-container_4CfSm2.png",

  // Additional button frames/backgrounds referenced by styles
  "https://cdn.navalabs.io/assets/button/blue-btn-border_bGaHLa.png",
  "https://cdn.navalabs.io/assets/button/dark-blue-panel-border_chwzSE.png",
  "https://cdn.navalabs.io/assets/button/error-btn-border_oqTNtY.png",
  "https://cdn.navalabs.io/assets/button/pill-btn-border_Trpfsv.png",
  "https://cdn.navalabs.io/assets/button/pill-btn-white-border_sddNWh.png",
  "https://cdn.navalabs.io/assets/button/primary-btn-border_aKEITH.png",
  "https://cdn.navalabs.io/assets/button/secondary-btn-border_DhutrW.png",

  // Inputs
  "https://cdn.navalabs.io/assets/input/custom-input-field-error_qAOtjh.png",
  "https://cdn.navalabs.io/assets/input/custom-input-field-focus_qGEwWX.png",
  "https://cdn.navalabs.io/assets/input/custom-input-field_ORgTzq.png",
  "https://cdn.navalabs.io/assets/input/input-field_VikYAE.png",
  "https://cdn.navalabs.io/assets/input/input-field-active_CmMAaI.png",
  "https://cdn.navalabs.io/assets/input/input-field-invalid_KOfLzQ.png",

  // Other assets
  "https://cdn.navalabs.io/assets/add-token-bg_GIXWVh.png",
  "https://cdn.navalabs.io/assets/tab/tablist_GLlHiG.png",
  "https://cdn.navalabs.io/assets/toggle_etfSVD.png",
  "https://cdn.navalabs.io/assets/wall-border_cZYlku.png",
  "https://cdn.navalabs.io/assets/long-toggle-border_XMKejH.png",
  "https://cdn.navalabs.io/assets/bg-full_cJmDRn.png",
  "https://cdn.navalabs.io/assets/short-plus_OTfPpU.png",
  "https://cdn.navalabs.io/assets/lose-bar_ABlNkU.png",
  "https://cdn.navalabs.io/assets/trellis_YpuLLp.png",
  "https://cdn.navalabs.io/assets/bronze-pod_KrdVGG.png",
  "https://cdn.navalabs.io/assets/trophy-rush_WsDPjc.png",
  "https://cdn.navalabs.io/assets/short-minus_rhJOcr.png",
  "https://cdn.navalabs.io/assets/arena-cropped_HhbSnf.png",
  "https://cdn.navalabs.io/assets/arena-night_XDeccs.png",
  "https://cdn.navalabs.io/assets/bg-rush_NLMfkn.PNG",
  "https://cdn.navalabs.io/assets/long-minus_mBEuby.png",
  "https://cdn.navalabs.io/assets/silver-trophy_YRrXAm.png",
  "https://cdn.navalabs.io/assets/wall-night_ByiRja.png",
  "https://cdn.navalabs.io/assets/vip-icon_34gRDj.png",
  // "https://cdn.navalabs.io/assets/bgm-join_NtqOlx.mp3", // audio is preloaded via <audio preload="auto" />
  "https://cdn.navalabs.io/assets/gold-pod_BCsGGS.png",
  "https://cdn.navalabs.io/assets/varentino_jFPzPH.png",
  "https://cdn.navalabs.io/assets/silver-pod_xmzyac.png",
  "https://cdn.navalabs.io/assets/gold-trophy_JGcXBt.png",
  "https://cdn.navalabs.io/assets/bg-live-tournament_JeXUeg.png",
  "https://cdn.navalabs.io/assets/prize-detail-button_XkxZtz.png",
  "https://cdn.navalabs.io/assets/short-toggle-border_JoKUXT.png",
  "https://cdn.navalabs.io/assets/bronze-trophy_WWzMwV.png",
  "https://cdn.navalabs.io/assets/long-plus_SkiiRU.png",
  "https://cdn.navalabs.io/assets/calendar-icon_RSUROs.png",
  "https://cdn.navalabs.io/assets/skull_pyynhW.png",
  "https://cdn.navalabs.io/assets/banner_cKbtBa.png",
  "https://cdn.navalabs.io/assets/token-mascot-TEMP_euuVaq.png",
  // Frequently used UI icons and bars
  "https://cdn.navalabs.io/assets/icon_check_JVuGuy.png",
  "https://cdn.navalabs.io/assets/settings_button_pjTONX.png",
  USDC_ICON,
  "https://cdn.navalabs.io/assets/deposit_fFMtar.png",
  "https://cdn.navalabs.io/assets/withdraw_cyOnwD.png",
  "https://cdn.navalabs.io/assets/export-pk_MYlxuw.png",
  "https://cdn.navalabs.io/assets/animated-loading_eluzLF.png",
  "https://cdn.navalabs.io/assets/win-history-bar_TUsghf.png",
  "https://cdn.navalabs.io/assets/lose-history-bar_qIjGmT.png",
  "https://cdn.navalabs.io/assets/win-status-bar_GUZYol.png",
  "https://cdn.navalabs.io/assets/lose-status-bar_lOgkqQ.png",
  "https://cdn.navalabs.io/assets/basic-trophy_jMFfgc.png",
  "https://cdn.navalabs.io/icons/trophy-icon_zozppj.png",
  "https://cdn.navalabs.io/assets/arrow-select_yhEOlT.png",
  "https://cdn.navalabs.io/assets/referrals_zJQBQC.png",
  "https://cdn.navalabs.io/assets/icon_pencil_YTcZwO.png",
  "https://cdn.navalabs.io/assets/icon_trash_DrSckZ.png",
  // Containers used by CSS borders
  "https://cdn.navalabs.io/assets/gold-container_DwdAIz.png",
  "https://cdn.navalabs.io/assets/silver-container_FKWHwM.png",
  "https://cdn.navalabs.io/assets/bronze-container_HkWCPH.png",
  "https://cdn.navalabs.io/icons/piggy_filled_dzrxqj.png",
  "https://cdn.navalabs.io/icons/piggy_idle_q1vaha.png",
  // Tier badges
  "https://cdn.navalabs.io/assets/badges/badge-pro_j8hYXt.png",
  "https://cdn.navalabs.io/assets/badges/badge-rookie_j8hYXt.png",
  // Remote assets frequently used in UI
  "https://cdn.navalabs.io/icons/trophy-icon_zozppj.png",
  USDC_ICON,
  "https://cdn.navalabs.io/icons/timer_rqnxy6.png",
  "https://cdn.navalabs.io/icons/padlock_pp8r8b.png",
  "https://cdn.navalabs.io/animated-trophy_gljtag.png",
  "https://cdn.navalabs.io/icons/freepass_j7fqhb.png",
  "https://cdn.navalabs.io/icons/gacha-icon_Gf5APY.png",
  // Onboarding/branding
  "https://cdn.navalabs.io/logo-centered_ss3uhg.png",
  "https://cdn.navalabs.io/varentino_vm8ad9.png",
  "https://cdn.navalabs.io/cloud_qinupq.png",
  // Hilumia pins and map extras
  "https://cdn.navalabs.io/icons/pin_mnldpc.svg",
  "https://cdn.navalabs.io/ground_cip0le.png",
  // CSS border-images (match classes in ui/styles.css)
  "https://cdn.navalabs.io/components/blue-container_dfcqao.png",
  "https://cdn.navalabs.io/components/dark-blue-bg_setf02.png",
  "https://cdn.navalabs.io/components/blue-sheet_kmy5al.png",
  "https://cdn.navalabs.io/components/dark-blue-container_eanjbn.png",
  "https://cdn.navalabs.io/components/brown-container_j0168m.png",
  "https://cdn.navalabs.io/components/red-container_omvjww.png",
  "https://cdn.navalabs.io/components/green-container_djhhxe.png",
  "https://cdn.navalabs.io/components/winning-bar_xfxyyi.png",
  "https://cdn.navalabs.io/components/losing-bar_huddpt.png",

  // Error / 404 page assets
  "/assets/404.png",

  // Rush bonus badge
  "/assets/discon_green.png",

  // Mission widget assets
  "/assets/alternative-green-container.png",
  "/assets/alternative-purple-container.png",
  "/assets/daily-bonus-tracker-bg.png",
  "/assets/daily-progress-mission.png",
  "/assets/weekly-bonus-tracker-bg.png",
  "/assets/weekly-progress-mission.png",

  // Winner dialog assets
  "/assets/winner-dialog.png",
  // Garden map assets
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/1.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/2.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/3.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/4.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/5.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/tiles/6.png`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/intro-cloud-1.jpg`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/intro-cloud-2.jpg`,
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}/map/intro-cloud-3.jpg`,

  // Pins
  // "/garden/img/pins/56fitnesspin.png",
  // "/garden/img/pins/9pin.png",
  // "/garden/img/pins/dojangpin.png",
  // "/garden/img/pins/emberpin.png",
  // "/garden/img/pins/gardenexpresspin.png",
  // "/garden/img/pins/gsppin.png",
  // "/garden/img/pins/hiluhallpin.png",
  // "/garden/img/pins/loveislandpin.png",
  // "/garden/img/pins/modapin.png",
  // "/garden/img/pins/slowpokespin.png",

  // Pin hovers
  // "/garden/img/pins/hover/56fitness.png",
  // "/garden/img/pins/hover/9lives.png",
  // "/garden/img/pins/hover/dojang.png",
  // "/garden/img/pins/hover/ember.png",
  // "/garden/img/pins/hover/gardenexpress.png",
  // "/garden/img/pins/hover/gsp.png",
  // "/garden/img/pins/hover/hiluhall.png",
  // "/garden/img/pins/hover/loveisland.png",
  // "/garden/img/pins/hover/moda.png",
  // "/garden/img/pins/hover/slowpokes.png",
  // "/garden/img/pins/hover/under2.svg",
  // "/garden/img/pins/hover/yuki2.svg",

  "https://cdn.navalabs.io/assets/bg-koth_pvTrwA.png",
  "https://cdn.navalabs.io/assets/bgm-join_NtqOlx.mp3",
  "https://cdn.navalabs.io/assets/bronze-wta_qFuhdj.png",
  "https://cdn.navalabs.io/assets/BUILDING_NoAyzL.png",
  "https://cdn.navalabs.io/assets/button/default-btn-white_LlUmFq.png",
  "https://cdn.navalabs.io/assets/colosseum-logo_WKpBWz.png",
  "https://cdn.navalabs.io/assets/CROSS_HtRPka.png",
  "https://cdn.navalabs.io/assets/dark-gray-panel-border_bLGRZv.png",
  "https://cdn.navalabs.io/assets/dark-green-panel-border_yLsAOs.png",
  "https://cdn.navalabs.io/assets/dark-varentino_pEKOvE.png",
  "https://cdn.navalabs.io/assets/data-bar-1_kmjEOG.png",
  "https://cdn.navalabs.io/assets/data-bg_KpQejF.png",
  "https://cdn.navalabs.io/assets/filter-icon_yTCyuk.png",
  "https://cdn.navalabs.io/assets/gold-wta_CSchVN.png",
  "https://cdn.navalabs.io/assets/input/input-field-border-light_IIZFUX.png",
  "https://cdn.navalabs.io/assets/item-double-trophy_YXpSbj.svg",
  "https://cdn.navalabs.io/assets/koth-blue-squad_ydswjk.png",
  "https://cdn.navalabs.io/assets/koth-crown_OFkpRG.png",
  "https://cdn.navalabs.io/assets/koth-frame-TEMP_jxOIui.png",
  "https://cdn.navalabs.io/assets/koth-gold-panel_TjQIOk.png",
  "https://cdn.navalabs.io/assets/koth-header_eGXblg.png",
  "https://cdn.navalabs.io/assets/splash-pro-arena_4zCqWh.png",
  "https://cdn.navalabs.io/assets/splash-rookie-island_4zCqWh.png",
  "https://cdn.navalabs.io/assets/koth-panel_gyglYm.png",
  "https://cdn.navalabs.io/assets/koth-sheet_LhOEfU.png",
  "https://cdn.navalabs.io/assets/koth-value-field-blue_BaDsAR.png",
  "https://cdn.navalabs.io/assets/koth-value-field_TkMwaS.png",
  "https://cdn.navalabs.io/assets/koth-vs_LuYcwO.png",
  "https://cdn.navalabs.io/assets/mode-bar_qJwUsb.png",
  "https://cdn.navalabs.io/assets/rank_VhfVGe.png",
  "https://cdn.navalabs.io/assets/silver-wta_oeRdak.png",
  "https://cdn.navalabs.io/assets/star-plain_QeQgsM.png",
  "https://cdn.navalabs.io/assets/wall-wta_joopCF.png",
  "https://cdn.navalabs.io/assets/wta-banner_ebOWJz.png",
  "https://cdn.navalabs.io/assets/x-close-big_NKTvvb.svg",
  "https://cdn.navalabs.io/components/primary-button_k5dopp.png",
  "https://cdn.navalabs.io/backgrounds/bg_rush_completed_vk6swr.png",
  "https://cdn.navalabs.io/components/black-container_fgfgdq.png",
  "https://cdn.navalabs.io/rolling_list_frame_xokld8.png",
  "https://cdn.navalabs.io/components/neon_bar_on_wxffcb.png",
  "https://cdn.navalabs.io/components/neon_bar_on_xupajm.png",
  "https://cdn.navalabs.io/icons/auto_join_aevgan.png",
  "https://cdn.navalabs.io/icons/icon-single-round_azwu59.png",
  "https://cdn.navalabs.io/components/primary-button-green_g0b31w.png",
  "https://cdn.navalabs.io/components/primary-button-red_ygrkgk.png",
  "https://cdn.navalabs.io/components/white-bg_cy14nm.png",
  "https://cdn.navalabs.io/components/king-token-container_d6x9tw.png",
  "https://cdn.navalabs.io/assets/stock-token-container_ktCx22.png",
  "https://cdn.navalabs.io/components/speech-bubble-container_3_owqocs.png",
  "https://cdn.navalabs.io/icons/valentino-head_fh2q2k.png",
  "https://cdn.navalabs.io/logo-abbreviated_dznpoc.png",
  "https://cdn.navalabs.io/icons/missions_fzis7h.png",
  "https://cdn.navalabs.io/icons/calendar_88ubF.png",
  "https://cdn.navalabs.io/map-detailed_KqW3ey.png",

  // SHOP
  "https://cdn.navalabs.io/components/shop/shop-tent_i48f33.png",
  "https://cdn.navalabs.io/components/shop/discount-tag_eHt2Zm.png",
  "https://cdn.navalabs.io/components/shop/item-podium_2SRqqz.png",
  "https://cdn.navalabs.io/components/shop/premium-offer_A3rLFG.png",
  "https://cdn.navalabs.io/components/shop/shop-icon_6jx9zo.png",
  "https://cdn.navalabs.io/components/gacha/coupon_6SsA9g.png",

  // GACHA
  "https://cdn.navalabs.io/components/gacha/gacha-ball-reveal_38G3Es.png",
  "https://cdn.navalabs.io/components/gacha/gacha-transition-opened_HxhYC8.png",
  "https://cdn.navalabs.io/components/gacha/title-common_rHv6s4.png",
  "https://cdn.navalabs.io/components/gacha/title-epic_h6EDr6.png",
  "https://cdn.navalabs.io/components/gacha/title-legendary_Zg7Kot.png",
  "https://cdn.navalabs.io/components/gacha/frog-idle_8GGDah.png",
  "https://cdn.navalabs.io/components/gacha/racoon-idle_5zFsRB.png",
  "https://cdn.navalabs.io/components/gacha/dragon-idle_RTpR23.png",
  "https://cdn.navalabs.io/components/gacha/pointer_A42Em2.png",

  // MISC
  "https://cdn.navalabs.io/double-icon_4iL4Vk.png",

  // LOCKED BUILDING OVERLAYS
  "https://cdn.navalabs.io/buildings/overlay/rush-overlay_21atpX.png",
  "https://cdn.navalabs.io/buildings/overlay/store-overlay_gEFRR1.png",
  "https://cdn.navalabs.io/buildings/overlay/alpha-dome-overlay_69zrfZ.png",
  "https://cdn.navalabs.io/buildings/overlay/gacha-overlay_61atpR.png",
  "https://cdn.navalabs.io/buildings/overlay/grand-rush-overlay_6u7jwZ.png",
  "https://cdn.navalabs.io/buildings/overlay/koth-overlay_0u7qsV.png",
  "https://cdn.navalabs.io/buildings/overlay/wta-overlay_7u7jwN.png",
  "https://cdn.navalabs.io/buildings/rush_M8uCpv.png",

  // PODIUM
  "https://cdn.navalabs.io/buildings/podium/podium_7ysE3E.png",
  "https://cdn.navalabs.io/buildings/podium/podium-pro_3zbC9H.png",

  // LUCKY DRAW
  "https://cdn.navalabs.io/components/lucky-draw/bg-lucky-draw_m8vkrp.png",
  "https://cdn.navalabs.io/components/lucky-draw/lucky-draw-box_z4tqhn.png",
  "https://cdn.navalabs.io/components/lucky-draw/lucky-draw-desk_b9xjcw.png",
  "https://cdn.navalabs.io/components/lucky-draw/lucky-draw-light_p2lsdf.png",
  "https://cdn.navalabs.io/components/lucky-draw/lucky-draw-stand_r7kqmx.png",
  "https://cdn.navalabs.io/icons/ticket_33hdbL.png",
  "https://cdn.navalabs.io/card-lucky-ticket_iplugh.png",
  "https://cdn.navalabs.io/card-trophy-30k_hlt1xv.png",

  // LUCKY DRAW HISTORY
  "/assets/lucky-draw-distributed-bg.png",
  "/assets/lucky-draw-live-bg.png",
  "/assets/lucky-draw-distributed-screen.png",
  "/assets/lucky-draw-live-screen.png",
  "/assets/flag-gold.png",
  "/assets/flag-silver.png",
  "/assets/flag-bronze.png",
  "/assets/lucky-ticket-solid.png",
  "/assets/ld-end-header_hh4uyZ.png",
  "/assets/ld-live-header_uu2Zhy.png",

  // Onboarding Step Dialog
  "https://cdn.navalabs.io/images/quick-tutorial/championship_XjNsv2.png",
  "https://cdn.navalabs.io/images/quick-tutorial/draft_54DvR6.png",
  "https://cdn.navalabs.io/images/quick-tutorial/earn_9ptEma.png",
  "https://cdn.navalabs.io/images/quick-tutorial/leaderboard_HeFDh8.png",
  "https://cdn.navalabs.io/images/quick-tutorial/pnl_yN5jC6.png",
  "https://cdn.navalabs.io/images/quick-tutorial/volatility_o4N8Cw.png",
  "https://cdn.navalabs.io/images/quick-tutorial/win-prizes_Z6An3J.png",
];

// Src assets
const SRC_ASSETS = [
  "/src/assets/logo.png",
  "/src/assets/field.svg",
  "/src/assets/trophy_with_wing_bronze.svg",
  "/src/assets/trophy_with_wing_gold.svg",
  "/src/assets/trophy_with_wing_silver.svg",
  "/src/assets/trophy_with_wing_steel.svg",
  "/src/assets/skull_outplayed.svg",
  "/src/assets/sns-circle.svg",
  "/src/assets/sns-white.svg",
  "/src/assets/point.svg",
  "/src/assets/seeker-holder-icon.svg",
  "/src/assets/loading-3-dot.svg",
  "/src/assets/icon/watch-duration.svg",
];

// Fonts
const FONTS = [
  "https://cdn.navalabs.io/fonts/DeadRevolverDisplay_yJiRdD.ttf",
  "https://cdn.navalabs.io/fonts/DeadRevolverGame_rrLKdh.ttf",
  "https://cdn.navalabs.io/fonts/m6x11_FSzbdl.ttf",
  "https://cdn.navalabs.io/fonts/m6x11plus_rwCbQd.ttf",

  "https://cdn.navalabs.io/fonts/DeadRevolverDisplayOutlined_KsfnCe.ttf",
];

// Music/audio assets
const MUSIC_ASSETS = [
  // Match
  "https://cdn.navalabs.io/audios/MATCH_xyhhwm.ogg",
  // Menu
  "https://cdn.navalabs.io/audios/MENU_lzbqwr.ogg",
];

const PLAYER_CARDS = [
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_3215.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_4199.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_6323.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_2629.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_6198.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_2867.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_6307.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_6528.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_3506.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_7238.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_277.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_2333.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_721.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1344.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_6065.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_3998.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_7224.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_778.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_6847.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4723.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_5084.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_95.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_2961.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_124.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_7020.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_5073.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_5232.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_6339.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_1510.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4298.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_5318.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_4562.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_736.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_1367.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_2024.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1120.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_4675.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1053.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_5847.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_5798.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_4380.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_4574.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_661.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_5681.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_196.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_2793.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_10011.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_4632.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_5128.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_4855.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1030.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_5498.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_6446.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_2860.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_2937.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4519.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_10695.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_40.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_447.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_5018.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_7342.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_6716.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_322.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1711.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_1493.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_6737.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_1012.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_1248.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1042.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_257.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_572.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_692.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/polar_bear/Polar%20Bear_1012.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_862.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_793.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_800.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_897.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_2634.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_2744.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_3216.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_3269.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_2652.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_108.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_4011.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_4036.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4067.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4088.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_6997.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4414.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4469.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_1676.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_4629.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_4779.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_195.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1284.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4851.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_5223.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/polar_bear/Polar%20Bear_1329.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_5609.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_2693.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_6261.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_2.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_7024.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_6993.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_7022.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_10563.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_7448.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_4351.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_931.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_7473.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1298.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_7581.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_7709.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_1443.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_2559.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_7961.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/polar_bear/Polar%20Bear_104.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_2848.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_8138.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/polar_bear/Polar%20Bear_122.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1648.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_8294.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_8440.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_8504.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_173.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_8542.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1001.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_8692.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_8698.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_8729.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_197.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_2038.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_8807.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_8951.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_9053.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_9196.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_110.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_10144.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_9276.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_1067.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_9324.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_10140.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_1288.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_9523.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_9589.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_2135.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_9704.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_10000.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_9771.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_10070.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_9795.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_9910.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_1178.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_10088.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_10119.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_266.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_10236.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_10185.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_10292.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_10360.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_10416.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_1314.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_1343.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_2232.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_10516.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_10591.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_10557.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_2121.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_10660.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_10799.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_10827.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_311.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_10914.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_1090.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_11020.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_11017.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_10973.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_11063.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_2594.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_10117.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_3053.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1168.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_3665.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_3774.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_3237.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_3848.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/frog/Frog_105.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_2484.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_4071.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4185.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/polar_bear/Polar%20Bear_2110.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/duck/Duck_4363.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_4456.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_4528.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4519.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_3229.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bear/Bear_4760.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_4813.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_222.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bobcat/Bobcat_3145.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_2998.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/tiger/Tiger_1285.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/dog/Dog_3828.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/capybara/Capybara_3824.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/octopus/Octopus_1445.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/parakeet/Parakeet_10120.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_445.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/pig/Pig_4214.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/sloth/Sloth_4293.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/wolf/Wolf_4389.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_4639.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/fish/Fish_4785.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/lion/Lion_1005.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/bat/Bat_4983.png",
  "https://qpurukhqnrwjwytkcjre.supabase.co/storage/v1/object/public/player-cards/gator/Gator_4991.png",
];

export const ALL_ASSETS = [...PUBLIC_ASSETS, ...SRC_ASSETS];

const FONT_EXTENSIONS = new Set([".ttf", ".woff", ".woff2", ".otf"]);
const AUDIO_EXTENSIONS = new Set([".ogg"]);

function extractExtension(asset: string): string {
  const normalized = asset.split("?")[0];
  const dotIndex = normalized.lastIndexOf(".");
  return dotIndex >= 0 ? normalized.substring(dotIndex).toLowerCase() : "";
}

const CORS_IMAGE_PREFIXES = [
  `${configs.ASSET_ORIGIN}${configs.ASSET_MAP_PATH}`,
  "https://cdn.navalabs.io/buildings/",
];

export function preloadImage(src: string): Promise<void> | undefined {
  if (CORS_IMAGE_PREFIXES.some((prefix) => src.startsWith(prefix))) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => resolve();
      img.onerror = () => reject(new Error(`Failed to load ${src}`));
      img.src = src;
    });
  }
  preload(src, {
    as: "image",
  });
}

export function preloadFont(fontUrl: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const font = new FontFace("preload-font", `url(${fontUrl})`, {
      weight: "400 900",
    });
    font
      .load()
      .then(() => {
        document.fonts.add(font);
        resolve();
      })
      .catch(reject);
  });
}

export function preloadAudio(src: string): Promise<void> {
  return new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.preload = "auto";

    if (/^https?:\/\//i.test(src)) {
      audio.crossOrigin = "anonymous";
    }

    const handleSuccess = () => {
      audio.removeEventListener("canplaythrough", handleSuccess);
      audio.removeEventListener("loadeddata", handleSuccess);
      audio.removeEventListener("error", handleError);
      resolve();
    };

    const handleError = () => {
      audio.removeEventListener("canplaythrough", handleSuccess);
      audio.removeEventListener("loadeddata", handleSuccess);
      audio.removeEventListener("error", handleError);
      reject(new Error(`Failed to load ${src}`));
    };

    audio.addEventListener("canplaythrough", handleSuccess);
    audio.addEventListener("loadeddata", handleSuccess);
    audio.addEventListener("error", handleError);

    audio.src = src;
    audio.load();
  });
}

export async function preloadAllAssets(
  onProgress?: (loaded: number, total: number) => void,
): Promise<void> {
  const allResources = [...ALL_ASSETS, ...FONTS, ...MUSIC_ASSETS];
  const total = allResources.length;
  let loaded = 0;

  const promises = allResources.map(async (asset) => {
    try {
      // Check if it's a font, audio, or image
      const extension = extractExtension(asset);

      if (FONT_EXTENSIONS.has(extension)) {
        await preloadFont(asset);
      } else if (AUDIO_EXTENSIONS.has(extension)) {
        await preloadAudio(asset);
      } else {
        await preloadImage(asset);
      }
      loaded++;
      onProgress?.(loaded, total);
    } catch (error) {
      console.warn(`Failed to preload: ${asset}`, error);
      loaded++;
      onProgress?.(loaded, total);
    }
  });

  await Promise.all(promises);
}

export async function preloadPlayerCards(options?: {
  urls?: string[];
  concurrency?: number;
  onItem?: (loaded: number, total: number, url: string) => void;
  signal?: AbortSignal;
}): Promise<void> {
  const urls = options?.urls ?? PLAYER_CARDS;
  const total = urls.length;
  let loaded = 0;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const conn: any = (navigator as any).connection;
  if (conn?.saveData) return; // respect data saver

  let concurrency = Math.max(1, options?.concurrency ?? 4);
  const type = (conn?.effectiveType ?? "").toString().toLowerCase();
  if (type.includes("2g")) concurrency = 1;
  else if (type.includes("3g"))
    concurrency = Math.max(1, Math.floor(concurrency / 2));

  const abortSignal = options?.signal;

  async function worker(url: string) {
    if (abortSignal?.aborted) return;
    try {
      await preloadImage(url);
    } catch {
      // ignore errors; best-effort warmup
    } finally {
      loaded++;
      options?.onItem?.(loaded, total, url);
    }
  }

  const queue = [...urls];
  const running: Promise<void>[] = [];

  async function runNext() {
    if (abortSignal?.aborted) return;
    const next = queue.shift();
    if (next === undefined) return;
    await worker(next);
    if (!abortSignal?.aborted && queue.length) {
      await runNext();
    }
  }

  const parallel = Math.min(concurrency, queue.length || 1);
  for (let i = 0; i < parallel; i++) {
    running.push(runNext());
  }
  await Promise.all(running);
}
